import { render } from "./AddElementaryRooms.vue?vue&type=template&id=13841d76"
import script from "./AddElementaryRooms.vue?vue&type=script&lang=js"
export * from "./AddElementaryRooms.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__